"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniq = exports.enquote = exports.ensureArray = void 0;
function ensureArray(t) {
    return t == null ? [] : Array.isArray(t) ? [...t] : [t];
}
exports.ensureArray = ensureArray;
const enquote = (text) => `"${text}"`;
exports.enquote = enquote;
function uniq(values, keygen) {
    const cache = new Set();
    return values.filter(value => {
        const key = keygen(value);
        if (cache.has(key))
            return false;
        cache.add(key);
        return true;
    });
}
exports.uniq = uniq;
